module.exports = __webpack_public_path__ + "static/tredo-logo-2bbe622d04dfb03d4b1fdede57e6ca11.png";